// src/locales/si/creditNote.js
export const creditNote = {
  // Page titles
  creditNotes: 'ණය සටහන්',
  allCreditNotes: 'සියලුම ණය සටහන්',
  createCreditNote: 'ණය සටහනක් සාදන්න',
  createCreditNoteDescription: 'මුල් ඇණවුමකට එරෙහිව ණය සටහනක් නිකුත් කරන්න',
  creditNoteDetails: 'ණය සටහන් විස්තර',
  viewAndManageAllCreditNotes: 'සියලුම ණය සටහන් බලන්න සහ කළමනාකරණය කරන්න',

  // List columns
  creditNoteNumber: 'ණය සටහන් #',
  customer: 'ගනුදෙනුකරු',
  originalOrder: 'මුල් ඇණවුම',
  sourceType: 'මූලාශ්‍රය',
  amount: 'මුදල',
  balance: 'ශේෂය',
  appliedAmount: 'යොදන ලද මුදල',
  remainingAmount: 'ඉතිරි මුදල',
  reason: 'හේතුව',
  createdBy: 'සාදන ලද්දේ',
  createdAt: 'සාදන ලද දිනය',
  status: 'තත්ත්වය',
  actions: 'ක්‍රියා',

  // Status labels — used via t(`creditNote.status_${note.status}`)
  status_issued:    'නිකුත් කරන ලදී',
  status_applied:   'යොදන ලදී',
  status_cancelled: 'අවලංගු කරන ලදී',

  // Source type labels — used via t(`creditNote.sourceType_${note.sourceType}`)
  sourceType_return:           'ආපසු භාරදීම',
  sourceType_price_adjustment: 'මිල ගැලපීම',
  sourceType_goodwill:         'සුහදශීලී ණය',

  // Form fields
  selectCustomer: 'ගනුදෙනුකරු තෝරන්න',
  allCustomers: 'සියලුම ගනුදෙනුකරුවන්',
  selectOriginalOrder: 'ඇණවුම තෝරන්න',
  amountPlaceholder: 'ණය සටහන් මුදල ඇතුළත් කරන්න',
  reasonPlaceholder: 'මෙම ණය සටහන සඳහා හේතුව ඇතුළත් කරන්න...',
  notes: 'සටහන්',
  notesPlaceholder: 'මෙම ණය සටහන පිළිබඳ සටහන් එකතු කරන්න...',

  // Actions
  create: 'ණය සටහන සාදන්න',
  issueCreditNote: 'ණය සටහන නිකුත් කරන්න',
  save: 'සුරකින්න',
  applyToOrder: 'ඇණවුමට යොදන්න',
  applyCreditNote: 'ණය සටහන යොදන්න',
  cancelCreditNote: 'ණය සටහන අවලංගු කරන්න',
  print: 'මුද්‍රණය කරන්න',
  printCreditNote: 'ණය සටහන මුද්‍රණය කරන්න',
  backToCreditNotes: 'ණය සටහන් වෙත ආපසු',

  // Confirmations
  confirmApply: 'තෝරාගත් ඇණවුමට මෙම ණය සටහන යොදන්නද?',
  confirmCancel: 'ඔබට මෙම ණය සටහන අවලංගු කිරීමට අවශ්‍ය බව විශ්වාසද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.',
  cancellationReason: 'අවලංගු කිරීමට හේතුව',
  cancellationReasonPlaceholder: 'අවලංගු කිරීමට හේතුව ඇතුළත් කරන්න...',
  applyAmount: 'යෙදිය යුතු මුදල',

  // Filters
  filterByStatus: 'තත්ත්වය අනුව පෙරහන් කරන්න',
  filterBySourceType: 'මූලාශ්‍රය අනුව පෙරහන් කරන්න',
  filterByCustomer: 'ගනුදෙනුකරු අනුව පෙරහන් කරන්න',
  dateFrom: 'සිට',
  dateTo: 'දක්වා',
  searchCreditNotes: 'ණය සටහන් #, ගනුදෙනුකරු අනුව සොයන්න...',
  allStatuses: 'සියලුම තත්ත්ව',
  allSourceTypes: 'සියලුම මූලාශ්‍ර',

  // Success / error messages
  creditNoteCreatedSuccessfully: 'ණය සටහන සාර්ථකව සාදන ලදී',
  creditNoteAppliedSuccessfully: 'ණය සටහන සාර්ථකව යොදන ලදී',
  creditNoteCancelledSuccessfully: 'ණය සටහන සාර්ථකව අවලංගු කරන ලදී',
  failedToCreateCreditNote: 'ණය සටහන සෑදීමට අසමත් විය',
  failedToApplyCreditNote: 'ණය සටහන යෙදීමට අසමත් විය',
  failedToCancelCreditNote: 'ණය සටහන අවලංගු කිරීමට අසමත් විය',
  failedToLoadCreditNotes: 'ණය සටහන් පූරණය කිරීමට අසමත් විය',
  failedToLoadCreditNoteDetails: 'ණය සටහන් විස්තර පූරණය කිරීමට අසමත් විය',
  someFieldsRequired: 'ඉදිරිපත් කිරීමට පෙර සලකුණු කළ ක්ෂේත්‍ර නිවැරදි කරන්න',

  // Validation
  customerRequired: 'කරුණාකර ගනුදෙනුකරුවෙකු තෝරන්න',
  originalOrderRequired: 'කරුණාකර ඇණවුමක් තෝරන්න',
  amountRequired: 'මුදල අවශ්‍යයි',
  amountMustBePositive: 'මුදල ශුන්‍යයට වඩා වැඩි විය යුතුය',
  amountExceedsOrderBalance: 'මුදල ඇණවුමේ නොගෙවූ ශේෂය ඉක්මවිය නොහැක',
  reasonRequired: 'හේතුව අවශ්‍යයි',
  applyAmountExceedsRemaining: 'යෙදිය යුතු මුදල ණය සටහනේ ඉතිරි ශේෂය ඉක්මවිය නොහැක',
  applyAmountExceedsOrderBalance: 'යෙදිය යුතු මුදල තෝරාගත් ඇණවුමේ නොගෙවූ ශේෂය ඉක්මවිය නොහැක',

  // Empty states
  noCreditNotesFound: 'ණය සටහන් හමු නොවීය',
  noCreditNotesFoundDescription: 'තවත් ණය සටහන් බැලීමට වත්මන් පෙරහන් සකස් කරන්න.',
  noCreditNotesYet: 'තවම ණය සටහන් නොමැත.',
  noCreditNotesYetDescription: 'ගනුදෙනුකරුවන්ගේ ආපසු ගෙවීම් හඹා යාම ආරම්භ කිරීමට ඔබේ පළමු ණය සටහන සාදන්න.',
  noCreditNotesMatchFilters: 'ඔබේ වත්මන් පෙරහන් වලට ගැලපෙන ණය සටහන් නොමැත',
  issueFirstCreditNote: 'පළමු ණය සටහන නිකුත් කරන්න',

  na: 'අදාළ නොවේ',
};
